// extracted by mini-css-extract-plugin
module.exports = {"benefit":"benefit_style_benefit__IQNoH","benefit-icon":"benefit_style_benefit-icon__2Ss_A","benefit-desc":"benefit_style_benefit-desc__2bPmp"};